import { LogoInfraAssistantColored } from "components/icons/generated";
import Icon from "ds/components/Icon";

type AiChatAvatarStaticProps = {
  size?: "default" | "large";
};

const AiChatAvatarStatic = ({ size = "default" }: AiChatAvatarStaticProps) => {
  return (
    <Icon
      src={LogoInfraAssistantColored}
      size={size === "default" ? "large" : "x-large"}
      noShrink
    />
  );
};

export default AiChatAvatarStatic;
